import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export const RSuppressionLists = t.readonlyArray(t.string);

/*
 * Type.
 */

export interface SuppressionListsModel extends t.TypeOf<typeof RSuppressionLists> {}

/*
 * IO methods.
 */

function parseSuppressionLists(src: any) {
  return Array.from(src).map((l: any) => l.list);
}

/*
 * API type.
 */

export const ApiSuppressionLists = makeApiType('suppressionLists', RSuppressionLists, parseSuppressionLists);
